import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, subTypeCode, sVer} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = () => openWindow(
        '/Ai',

        {
            prjId,
            scene: 'GENERATE_UDT',
            sVer,
        }
    )

    return {
        label: '迭代数据表',
        onClick,
    }
}
